import { useSeoMeta } from '@unhead/react';

const Index = () => {
  useSeoMeta({
    title: 'Test n-site',
    description: 'A simple test page for n-site deployment on Nostr.',
  });

  return (
    <div>
      <h1>Test n-site</h1>
      
      <p>
        This is a simple test page to verify n-site deployment on the Nostr protocol.
        An n-site is a website that is deployed to Nostr relays instead of traditional web hosting.
      </p>
      
      <p>
        If you're seeing this page, it means the n-site deployment is working correctly.
        The content you're reading right now is being served from the Nostr network.
      </p>
      
      <p>
        <a href="https://shakespeare.diy">Vibed with Shakespeare</a>
      </p>
    </div>
  );
};

export default Index;
